export const COMPANY_OPTION_PREFIX = 'c';
export const FAB_OPTION_PREFIX = 'f';
export const LAYOUT_OPTION_PREFIX = 'l';
export const USERNAME_OPTION_PREFIX = 'u';
export const ACTION_OPTION_PREFIX = 'a';

export const COMPANY_OPTION_KEY = 'c_root_id';
export const FAB_OPTION_KEY = 'f_root_id';
export const LAYOUT_OPTION_KEY = 'l_root_id';
export const USERNAME_OPTION_KEY = 'u_root_id';
export const ACTION_OPTION_KEY = 'a_root_id';

export const ACTION_COMEIN_ROOM_OPTION = '入室';
export const ACTION_LEAVE_ROOM_OPTION = '退室';

export const ACTION_OPTIONS = [
  {
    events_type: 0,
  },
  {
    events_type: 1,
  },
];

export const FILTER_OPTION_CONFIG = [
  {
    title: 'ユーザー名',
    dataKey: 'userOptions',
    key: USERNAME_OPTION_KEY,
    value: USERNAME_OPTION_KEY,
  },
  {
    title: 'アクション',
    dataKey: 'actionOptions',
    key: ACTION_OPTION_KEY,
    value: ACTION_OPTION_KEY,
  },
  // {
  //   title: 'Fab名',
  //   dataKey: 'fabOptions',
  //   key: FAB_OPTION_KEY,
  //   value: FAB_OPTION_KEY,
  // },
  {
    title: 'レイアウト名',
    dataKey: 'layoutOptions',
    key: LAYOUT_OPTION_KEY,
    value: LAYOUT_OPTION_KEY,
  },
  {
    title: '会社名',
    dataKey: 'companyOptions',
    key: COMPANY_OPTION_KEY,
    value: COMPANY_OPTION_KEY,
  },
];
